type Tone = 'pass' | 'fail' | 'warn' | 'open';
const stroke: Record<Tone, string> = {
  pass: 'var(--status-pass)',
  fail: 'var(--status-fail)',
  warn: 'var(--status-warn)',
  open: 'var(--status-open)',
};

export function DonutChart({
  segments,
  size = 120,
  ariaLabel,
}: {
  segments: { key: string; value: number; token: Tone }[];
  size?: number;
  // #121: Seit die Simplifications-Abdeckung ebenfalls einen Donut zeigt, gibt es zwei Ringe auf
  // derselben Seite. Ohne eigenen Namen tragen beide dieselbe generische Beschriftung — fuer
  // Screenreader (und fuer getByRole('img', { name })) sind sie dann nicht auseinanderzuhalten.
  // Die Karten geben ihre eigene Ueberschrift mit; ohne Angabe bleibt der bisherige Rueckfall.
  ariaLabel?: string | undefined;
}) {
  const r = size / 2 - 10;
  const c = 2 * Math.PI * r;
  const sum = segments.reduce((s, x) => s + x.value, 0) || 1;
  let offset = 0;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label={ariaLabel ?? 'Donut chart'}
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke="var(--bg-subtle)"
        strokeWidth={12}
      />
      {segments
        .filter((s) => s.value > 0)
        .map((s) => {
          const len = (s.value / sum) * c;
          const el = (
            <circle
              key={s.key}
              data-arc={s.key}
              cx={size / 2}
              cy={size / 2}
              r={r}
              fill="none"
              stroke={stroke[s.token]}
              strokeWidth={12}
              strokeDasharray={`${len} ${c - len}`}
              strokeDashoffset={-offset}
              transform={`rotate(-90 ${size / 2} ${size / 2})`}
            />
          );
          offset += len;
          return el;
        })}
    </svg>
  );
}
